<template>
  <div class='rkld'>
    <div class='rkldRight'>
      <div class='rkldRightContent'>
        <!-- tabs导航 -->
        <el-tabs v-model='editableTabsValue' type='card'>
          <el-tab-pane label="订餐信息" name='1'>
            <!--搜索框-->
            <div class='searchTj'>
              <div class='searchTjHead'>
                <span>查询条件</span>
                <el-button
                  style='
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    '
                  type='text'
                  @click.native='Resert'
                >
                  <i class='el-icon-refresh'></i>
                  刷新页面
                </el-button>
              </div>
              <el-form :model='form' class='searchTjContent'>
                <div
                  class='searchTjContentDiv'
                  v-show='searchValue'
                >
                                    <span
                                      class='searchTjContentDivSpan'
                                      style='margin-right: 0'
                                    >姓名</span
                                    >
                  <el-input
                    v-model='form.customerName'
                    placeholder='请输入'
                    class='searchTjContentDivInput'
                  ></el-input>
                </div>
                <div
                  class='searchTjContentDiv'
                  v-show='searchValue'
                >
                  <el-button
                    type='primary'
                    icon='el-icon-search'
                    @click='query'
                  >查询
                  </el-button
                  >
                </div>
                <div
                  class='searchTjContentDiv'
                  v-show='searchValue'
                >
                  <el-button
                    type='info'
                    icon='el-icon-delete'
                    @click='resert'
                  >清除条件
                  </el-button
                  >
                </div>
                <div
                  class='arrowDown'
                  @click='showSearch'
                  style='color: #000'
                >
                  <i class='el-icon-arrow-down'></i>
                </div>
              </el-form>
            </div>
            <!--功能模块-->
            <div class='searchButtonDiv' v-show='quanbu'>
              <div class='searchButtonDivLeft' style="visibility: hidden;">
                <el-button-group>
                  <el-button
                    icon='el-icon-plus'
                    type='success'
                    @click="handleClick('新增', 'add')"
                  >新增
                  </el-button
                  >
                  <el-button
                    icon='el-icon-close'
                    type='danger'
                    @click="batchDelete('删除')"
                  >批量删除
                  </el-button
                  >
                </el-button-group>
              </div>
              <!-- 筛选按钮 -->
              <div class='searchButtonDiveRight'>
                <el-button-group>
                  <el-button
                    type='primary'
                    icon='el-icon-refresh'
                    @click='resertTable'
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class='dropdown'
                    trigger='click'
                    :hide-on-click='false'
                  >
                                        <span class='el-dropdown-link'>
                                            <i
                                              class='el-icon-s-grid el-icon--right'
                                              style='color: #fff'
                                            ></i>
                                            <i
                                              class='el-icon-arrow-down el-icon--right'
                                            ></i>
                                        </span>
                    <el-dropdown-menu slot='dropdown'>
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model='checkList'
                            :min='1'
                            @change='tableShow'
                          >
                            <el-checkbox
                              label='序号'
                            >序号
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='姓名'
                            >姓名
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='餐补类型'
                            >餐补类型
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='订餐方式'
                            >订餐方式
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='取餐方式'
                            >取餐方式
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='余额'
                            >余额
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='剩余就餐次数'
                            >剩余就餐次数
                            </el-checkbox
                            >
                            <br />
                            <el-checkbox
                              label='操作'
                            >操作
                            </el-checkbox
                            >
                            <br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>
            <!--表单-->
            <div class='addForm'>
              <el-table
                ref='multipleTable'
                :data='tableDate'
                tooltip-effect='dark'
                @row-click='openDetails'
                highlight-current-row
                @selection-change='handleSelectionChange'
                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                border
              >
                <el-table-column
                  type='selection'
                  width='50'
                  align='center'
                  @selection-change='handleSelectionChange'
                >
                </el-table-column>
                <el-table-column
                  type='index'
                  width='70'
                  prop='order'
                  label='序号'
                  align='center'
                  v-if='no1'
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop='customerName'
                  label='姓名'
                  align='center'
                  v-if='no2'
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop='gradeName'
                  label='餐补类型'
                  align='center'
                  show-overflow-tooltip
                  v-if='no3'
                >
                </el-table-column>
                <el-table-column
                  prop='orderWay'
                  label='订餐方式'
                  align='center'
                  show-overflow-tooltip
                  v-if='no4'
                >
                  <template slot-scope='scope'>
                                        <span v-if="scope.row.orderWay == '0'"
                                        >按月</span
                                        >
                    <span v-if="scope.row.orderWay == '1'"
                    >按次</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop='takeWay'
                  label='取餐方式'
                  width='300'
                  align='center'
                  show-overflow-tooltip
                  v-if='no5'
                >
                  <template slot-scope='scope'>
                                        <span v-if='scope.row.takeWay == 0'
                                        >送餐</span
                                        >
                    <span v-if='scope.row.takeWay == 1'
                    >堂食</span
                    >
                    <span v-if='scope.row.takeWay == 2'
                    >自取</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop='orderBalance'
                  label='余额'
                  width='200'
                  align='center'
                  show-overflow-tooltip
                  v-if='no6'
                >
                </el-table-column>
                <el-table-column
                  prop='onlyTimes'
                  label='剩余就餐次数'
                  width='200'
                  align='center'
                  show-overflow-tooltip
                  v-if='no8'
                >
                  <template slot-scope='scope'>
                                        <span @click='showDialog(scope.row)'>
                                            {{ scope.row.onlyTimes }}
                                        </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop='operation'
                  label='操作'
                  align='center'
                  width='250px'
                  v-if='no7'
                >
                  <template slot-scope='scope'>
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='查看'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-chakan tabBtn'
                        @click="
                                                    handleClick(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                      ></button>
                    </el-tooltip>
                    <!--                    <el-tooltip-->
                    <!--                      class='item'-->
                    <!--                      effect='dark'-->
                    <!--                      content='编辑'-->
                    <!--                      placement='top-start'-->
                    <!--                    >-->
                    <!--                      <button-->
                    <!--                        style='color: #000'-->
                    <!--                        class='iconfont icon-bianji3 tabBtn'-->
                    <!--                        @click="-->
                    <!--                                                    handleClick(-->
                    <!--                                                        '编辑',-->
                    <!--                                                        scope.row-->
                    <!--                                                    )-->
                    <!--                                                "-->
                    <!--                      ></button>-->
                    <!--                    </el-tooltip>-->
                    <!-- <el-tooltip
                      class='item'
                      effect='dark'
                      content='订餐记录'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-chakan tabBtn'
                        @click='showDialog(scope.row)'
                      ></button>
                    </el-tooltip> -->
                    <el-tooltip
                      class='item'
                      effect='dark'
                      content='删除'
                      placement='top-start'
                    >
                      <button
                        style='color: #000'
                        class='iconfont icon-icon7 tabBtn'
                        @click='deleteItem(scope.row)'
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page='currentPage'
                :page-sizes='[10, 20, 50, 100]'
                :page-size='10'
                layout='total, sizes, prev, pager, next, jumper'
                :total='total'
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增功能模态框 -->
    <div class='addFrom'>
      <el-dialog
        :title='dialogTitle'
        :visible.sync='dialogVisible'
        width='990px'
        :before-close='handleClose'
      >
        <div class='addDialogTabs'>
          <div
            v-for='(item, index) in dialogTabs'
            :key='index'
            :class='{ borderBot: borderBotKey == index }'
            @click='selectDialogTabs(index)'
          >
            {{ item }}
          </div>
        </div>
        <el-form
          ref='addForm1'
          :model='addForm'
          :rules='addFormRules1'
          v-show='dialogBox == 0'
          label-width='100px'
        >
          <div class='dialogBody'>
            <el-row :gutter='24'>
              <el-col :span='9'>
                <el-form-item
                  label='姓名：'
                  prop='customerName'
                >
                  <el-input
                    v-model='addForm.customerName'
                    :disabled="dialogTitle === '查看'"
                  >
                    <el-button
                      slot='append'
                      :disabled="dialogTitle === '查看'"
                      icon='el-icon-search'
                      @click='lookRY'
                      style='margin-left: -15px'
                    ></el-button
                    >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label='性别：'
                  prop='customerSex'
                  style='margin-top: 20px'
                >
                  <el-select
                    v-model='addForm.customerSex'
                    placeholder=''
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                    style='width: 100%'
                  >
                    <el-option
                      v-for='item in sexOptions'
                      :key='item.value'
                      :label='item.label'
                      :value='item.value'
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label='民族：'
                  prop='nation'
                  style='margin-top: 20px'
                >
                  <el-select
                    v-model='addForm.nation'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                    placeholder=''
                    style='width: 100%'
                  >
                    <el-option
                      v-for='item in nation'
                      :key='item'
                      :label='item'
                      :value='item'
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label='手机号码：'
                  prop='customerPhone'
                  style='margin-top: 20px'
                >
                  <el-input
                    v-model='addForm.customerPhone'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label='人员编号：'
                  style='margin-top: 20px'
                  prop='faceIdcode'
                >
                  <el-input
                    v-model='addForm.faceIdcode'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='9'>
                <el-form-item
                  label='身份证号：'
                  prop='customerIdcard'
                >
                  <el-input
                    v-model='addForm.customerIdcard'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                    @change='searchPerson'
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label='出生年月：'
                  prop='customerBirthday'
                  style='margin-top: 20px'
                >
                  <el-date-picker
                    v-model='addForm.customerBirthday'
                    type='date'
                    placeholder='选择日期'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                    value-format='yyyy-MM'
                    style='width: 100%'
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label='年龄：'
                  prop='customerAge'
                  style='margin-top: 20px'
                >
                  <el-input
                    v-model='addForm.customerAge'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label='政治面貌：'
                  prop='customerPolitical'
                  style='margin-top: 20px'
                >
                  <el-select
                    v-model='addForm.customerPolitical'
                    :disabled="
                                            dialogTitle === '查看' ||
                                            dialogTitle === '新增'
                                        "
                    placeholder='政治面貌'
                  >
                    <el-option
                      label='中共党员'
                      value='0'
                    ></el-option>
                    <el-option
                      label='共青团员'
                      value='1'
                    ></el-option>
                    <el-option
                      label='群众'
                      value='2'
                    ></el-option>
                    <el-option
                      label='其他'
                      value='3'
                    ></el-option>
                  </el-select>
                </el-form-item>

                <!-- <el-form-item
                                    label="组织机构："
                                    style="height: 40px; margin-top: 20px"
                                    prop="orgName"
                                >
                                    <el-select
                                        style="width: 100%"
                                        class="marginT34"
                                        v-model="addForm.orgName"
                                        placeholder="请选择组织机构"
                                        ref="selectBoxRef"
                                        :disabled="dialogTitle === '查看' || dialogTitle === '新增'"
                                    >
                                        <el-option
                                            :value="addForm.orgName"
                                            style="height: auto"
                                        >
                                            <el-tree
                                                :data="orgList"
                                                :props="defaultProps"
                                                ref="tree"
                                                @node-click="
                                                    handleEditNodeClick
                                                "
                                                class="tree_box"
                                            ></el-tree>
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
              </el-col>
              <el-col :span='6'>
                <el-form-item
                  prop='customerPhoto'
                  label-width='0px'
                >
                  <el-upload
                    :disabled="dialogTitle === '查看'"
                    :show-file-list='false'
                    :action='actionUrl'
                    list-type='picture-card'
                    :limit='1'
                    :on-success='handleAvatarSuccess'
                    :before-upload='beforeAvatarUpload'
                    :on-preview='handlePicturePreview'
                    :on-exceed='handleExceed'
                  >
                    <img
                      v-if='addForm.customerPhoto'
                      :src='addForm.customerPhoto'
                      class='avatar'
                    />
                    <i
                      v-else
                      class='el-icon-plus avatar-uploader-icon'
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form-item
            label='居住情况：'
            prop='customerJzqk'
            style='display: contents'
          >
            <el-radio
              v-model='addForm.customerJzqk'
              label='1'
              :disabled="
                                dialogTitle === '查看' || dialogTitle === '新增'
                            "
            >独自居住
            </el-radio
            >
            <el-radio
              v-model='addForm.customerJzqk'
              label='2'
              :disabled="
                                dialogTitle === '查看' || dialogTitle === '新增'
                            "
            >与配偶居住
            </el-radio
            >
            <el-radio
              v-model='addForm.customerJzqk'
              label='3'
              :disabled="
                                dialogTitle === '查看' || dialogTitle === '新增'
                            "
            >与子女居住
            </el-radio
            >
            <el-radio
              v-model='addForm.customerJzqk'
              label='4'
              :disabled="
                                dialogTitle === '查看' || dialogTitle === '新增'
                            "
            >其他
            </el-radio
            >
          </el-form-item>
          <el-form-item
            label='经济来源：'
            prop='economySource'
            style='display: contents'
          >
            <el-checkbox-group
              v-model='addForm.economySource'
              :disabled="
                                dialogTitle === '查看' || dialogTitle === '新增'
                            "
            >
              <el-checkbox label='0'>养老金</el-checkbox>
              <el-checkbox label='1'>子女供养</el-checkbox>
              <el-checkbox label='2'>救济优抚</el-checkbox>
              <el-checkbox label='3'>兼职</el-checkbox>
              <el-checkbox label='4'>其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class='dialogBody'>
            <el-form-item label='居住地址：'>
              <el-button
                type='danger'
                icon='el-icon-location-outline'
                @click='location'
              >定位到标准地址
              </el-button
              >
            </el-form-item>
          </div>
          <el-form-item label='' v-show='mapshow'>
            <el-row>
              <el-col :span='4'>
                <el-form-item>
                  <el-select
                    v-model='addForm.provinceId'
                    placeholder='请选择省'
                    @change='handleProvince'
                    :disabled="
                                            normalInfo.orgLevel == 1 ||
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            dialogTitle == '查看'
                                        "
                    style='width: 100%'
                  >
                    <el-option
                      v-for='(
                                                item, index
                                            ) in provinceList'
                      :key='index'
                      :label='item.name'
                      :value='item.adcode'
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.cityid'
                  :disabled="
                                        normalInfo.orgLevel == 2 ||
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  placeholder='请选择市'
                  @change='handleCity'
                  style='width: 100%'
                >
                  <el-option
                    v-for='(item, index) in cityList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.zoneid'
                  :disabled="
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  placeholder='请选择区'
                  @change='handleArea'
                  style='width: 100%'
                >
                  <el-option
                    v-for='(item, index) in areaList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.streetid'
                  :disabled="
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  placeholder='请选择街道'
                  @change='streetChange'
                >
                  <el-option
                    v-for='(item, index) in streetList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode + index'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.shequid'
                  :disabled="
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  placeholder='请选择社区'
                >
                  <el-option
                    v-for='item in communityList'
                    :key='item.id'
                    :label='item.address'
                    :value='item.id'
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <!-- <el-input
              v-model.trim="addForm.customerAddress"
              :disabled="true"
              style="margin-top: 12px; margin-bottom: 12px"
              placeholder="请在地图的边界内点击选择详细信息"
            ></el-input> -->
            <el-form-item prop='customerAddress'>
              <input
                v-model.trim='addForm.customerAddress'
                :disabled="dialogTitle == '查看'"
                id='tipinput'
                class='el-input__inner'
                :class="dialogTitle == '查看' ? 'innerCur' : ''"
                @focus="getMap('tipinput')"
                placeholder='请输入关键字'
                autocomplete='off'
              />
            </el-form-item>
            <div class='map_container'>
              <div
                class='map_right'
                id='container'
                style='width: 100%; height: 300px'
              ></div>
            </div>
          </el-form-item>
        </el-form>
        <el-form
          ref='addForm2'
          :model='addForm'
          :rules='rules'
          v-show='dialogBox == 1'
          label-width='130px'
        >
          <el-form-item
            label='订餐方式：'
            prop='orderWay'
            width='100%'
          >
            <el-radio
              @change='exchange'
              v-model='addForm.orderWay'
              label='0'
              :disabled="dialogTitle === '查看'"
            >按月
            </el-radio
            >
            <el-radio
              @change='exchange'
              v-model='addForm.orderWay'
              label='1'
              :disabled="dialogTitle === '查看'"
            >按次
            </el-radio
            >
          </el-form-item>
          <el-form-item
            label='订餐开始时间'
            prop='orderStartTime'
            v-show='addForm.orderWay == 0'
          >
            <el-row :gutter='20' style='display: flex'>
              <el-col :span='20'>
                <el-date-picker
                  :disabled="dialogTitle === '查看'"
                  v-model='addForm.orderStartTime'
                  type='date'
                  size='small'
                  @change='linkage'
                  value-format='yyyy-MM-dd'
                  style='width: 100%'
                >
                </el-date-picker>
              </el-col>
              <el-col :span='4'>
                <span></span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label='订餐结束时间'
            prop='orderEndTime'
            v-show='addForm.orderWay == 0'
          >
            <el-row :gutter='20' style='display: flex'>
              <el-col :span='20'>
                <el-input
                  disabled
                  size='small'
                  width='100%'
                  v-model='addForm.orderEndTime'
                  placeholder='选择订餐开始时间计算订餐结束时间'
                ></el-input>
              </el-col>
              <el-col :span='4'>
                <span></span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label='订餐日期'
            prop='orderTimeOnec'
            v-show='addForm.orderWay == 1'
          >
            <el-row :gutter='20' style='display: flex'>
              <el-col :span='20'>
                <el-date-picker
                  :disabled="dialogTitle === '查看'"
                  type='dates'
                  style='width: 100%'
                  format='yyyy-MM-dd'
                  value-format='yyyy-MM-dd'
                  :picker-options='pickerOptions'
                  v-model='addForm.orderTimeOnec'
                  placeholder='选择一个或多个日期'
                >
                </el-date-picker>
              </el-col>
              <el-col :span='4'>
                <span></span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label='订餐类型：' prop='orderType'>
            <el-checkbox-group
              @change='groupCheck'
              v-model='addForm.orderType'
              :disabled="dialogTitle === '查看'||monthly"
            >
              <el-checkbox label='1'>早餐</el-checkbox>
              <el-checkbox label='2'>午餐</el-checkbox>
              <el-checkbox label='3'>晚餐</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label='金额：' prop='orderMoney'>
            <el-row :gutter='20' style='display: flex'>
              <el-col :span='20'>
                <el-input
                  :disabled="dialogTitle === '查看'"
                  v-model='addForm.orderMoney'
                  size='small'
                  width='100%'
                  placeholder='获取补贴金额'
                ></el-input>
              </el-col>
              <!--                            <el-col :span="4"-->
              <!--                                ><span @click="addVolunteer"-->
              <!--                                    >查看详情</span-->
              <!--                                ></el-col-->
              <!--                            >-->
            </el-row>
          </el-form-item>
          <el-form-item label='余额：' prop='orderBalance'>
            <el-row :gutter='20' style='display: flex'>
              <el-col :span='20'>
                <el-input
                  disabled
                  v-model='addForm.orderBalance'
                  size='small'
                  width='100%'
                  placeholder='获取余额'
                ></el-input>
              </el-col>
              <el-col :span='4'>
                <span></span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label='取餐方式：'
            prop='takeWay'
            @change.native='showAddress'
          >
            <el-radio
              v-model='addForm.takeWay'
              label='0'
              :disabled="dialogTitle === '查看'"
            >送餐
            </el-radio
            >
            <el-radio
              v-model='addForm.takeWay'
              label='1'
              :disabled="dialogTitle === '查看'"
            >堂食
            </el-radio
            >
            <el-radio
              v-model='addForm.takeWay'
              label='2'
              :disabled="dialogTitle === '查看'"
            >自取
            </el-radio
            >
          </el-form-item>
          <el-form-item
            label='地址是否正确：'
            prop='isAddress'
            v-if='showad'
            required
          >
            <el-radio
              v-model='addForm.isAddress'
              label='0'
              :disabled="dialogTitle === '查看'"
            >是
            </el-radio
            >
            <el-radio
              v-model='addForm.isAddress'
              label='1'
              :disabled="dialogTitle === '查看'"
            >否
            </el-radio
            >
          </el-form-item>
          <el-form-item label='居住地址：' v-if='showad' required>
            <el-row>
              <el-col :span='4'>
                <el-form-item>
                  <el-select
                    v-model='addForm.provinceId'
                    placeholder='请选择省'
                    :disabled="
                                            normalInfo.orgLevel == 1 ||
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            dialogTitle == '查看'
                                        "
                    @change='handleProvince'
                    style='width: 100%'
                  >
                    <el-option
                      v-for='(
                                                item, index
                                            ) in provinceList'
                      :key='index'
                      :label='item.name'
                      :value='item.adcode'
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.cityid'
                  placeholder='请选择市'
                  @change='handleCity'
                  :disabled="
                                        normalInfo.orgLevel == 2 ||
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  style='width: 100%'
                >
                  <el-option
                    v-for='(item, index) in cityList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.zoneid'
                  placeholder='请选择区'
                  :disabled="
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  @change='handleArea'
                  style='width: 100%'
                >
                  <el-option
                    v-for='(item, index) in areaList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.streetid'
                  placeholder='请选择街道'
                  :disabled="
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  @change='streetChange'
                >
                  <el-option
                    v-for='(item, index) in streetList'
                    :key='index'
                    :label='item.name'
                    :value='item.adcode + index'
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span='4' :offset='1'>
                <el-select
                  v-model='addForm.shequid'
                  :disabled="
                                        normalInfo.orgLevel == 5 ||
                                        dialogTitle == '查看'
                                    "
                  placeholder='请选择社区'
                >
                  <el-option
                    v-for='item in communityList'
                    :key='item.id'
                    :label='item.address'
                    :value='item.id'
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-form-item prop='address'>
              <input
                v-model.trim='addForm.customerAddress'
                :disabled="dialogTitle == '查看'"
                id='tipinput'
                class='el-input__inner'
                :class="dialogTitle == '查看' ? 'innerCur' : ''"
                @focus="getMap('tipinput')"
                placeholder='请输入关键字'
                autocomplete='off'
              />
            </el-form-item>
            <!-- :disabled="true" -->
          </el-form-item>
          <el-form-item
            label='部门：'
            prop='departmentId'
            v-if='showad'
          >
            <el-select
              :disabled="dialogTitle === '查看'"
              v-model='addForm.departmentId'
              placeholder='请选择'
              size='mini'
              style='width: 100%'
              @change='selectDepart'
            >
              <el-option
                v-for='item in subsidyLevelOptions'
                :key='item.value'
                :label='item.departmentName'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label='送餐人员：'
            prop='personId'
            v-if='showad'
          >
            <el-select
              :disabled="dialogTitle === '查看'"
              v-model='addForm.personId'
              placeholder='请选择'
              size='mini'
              style='width: 100%'
            >
              <el-option
                v-for='item in personIdOptions'
                :key='item.value'
                :label='item.personName'
                :value='item.id'
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
         <el-form
          ref='addForm2'
          :model='addForm'
          :rules='rules'
          v-show='dialogBox == 2'
          label-width='130px'
        >
           <!-- <visit-main
            :older="true"
            :openData="dialogInfo"
            @canclePerson="cancleSet"
        ></visit-main> -->

      <div class="visitMain" >
        <div class="visitTitle">
          <p class="name">姓名：</p>
          <p>电话：</p>
          <span
            class="iconfont icon-bodadianhua"
            style="font-size: 20px;position: relative;top: -4px;cursor: pointer;margin-left: 12px; "
          ></span>
        </div>

        <el-form
          :model="hfData"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="问题模板:">
            <el-select
              v-model="hfData.id"
              placeholder="请选择问题"
              style="width:100%"
              @change="setQuestionId"
              value-key="id"
            >
              <el-option
                :label="item.type"
                :value="item.id"
                v-for="item in pList"
                :key="item.id+''"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="'问题 '+(index+1)+'：'+item.problems"
            v-for="(item,index) in hfData.questionList"
            label-width="280px"
          >
            <el-input
              v-model="item.reasons"
              type="textarea"
              style="width:100%"
              placeholder="请输入你的回答"
            ></el-input>
          </el-form-item>
        </el-form>

      </div>

      <!-- <div class="footer">
        <el-button
          type="primary"
          @click="save"
          v-if="openData.title!=='查看'"
        >{{nextText}}</el-button>
        <el-button @click="dialogClose">{{openData.title=='查看'?'关闭':'取消'}}</el-button>
      </div> -->

        </el-form>

        <div slot='footer' v-if="dialogTitle != '查看'">
          <el-button type='primary' @click='submitForm'
          >确定
          </el-button
          >
          <el-button @click='dialogVisible = false'>取消</el-button>
        </div>
      </el-dialog>

      <!-- 人员信息弹框 -->
      <el-dialog
        :title='enteringLRTitle'
        :visible.sync='enteringLYDialog'
        width='60%'
        class='dialog_container'
        @close='enteringLRClose'
      >
        <div class='dialog_content'>
          <el-form
            :inline='true'
            class='demo-form-inline'
            style='padding-top: 10px; padding-bottom: 10px'
          >
            <el-form-item label='姓名:'>
              <el-input
                v-model='form1.customerName'
                placeholder='请输入姓名'
              ></el-input>
            </el-form-item>
            <el-form-item
              label='身份证号:'
              style='margin-left: 30px'
            >
              <el-input
                v-model='form1.customerIdcard'
                placeholder='请输入身份证号'
              ></el-input>
            </el-form-item>
            <el-form-item style='float: right'>
              <el-button type='primary' @click='query1'
              >查询
              </el-button
              >
              <!-- <el-button type="info" >重置</el-button> -->
            </el-form-item>
          </el-form>
          <el-table
            :data='RYTableData'
            tooltip-effect='dark'
            style='width: 100%'
            :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
            border
            @selection-change='handleSelectionChange1'
          >
            <el-table-column
              type='selection'
              width='55'
            ></el-table-column>
            <el-table-column
              type='index'
              width='70'
              label='序号'
              align='center'
            ></el-table-column>
            <!-- <el-table-column align="center" prop="volunteerArchiveCode" label="" :show-overflow-tooltip="true"></el-table-column> -->
            <el-table-column
              align='center'
              prop='customerName'
              label='姓名'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='customerIdcard'
              label='身份证号'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='customerPhone'
              label='手机号'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='customerAge'
              label='年龄'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='customerSex'
              label='性别'
              :show-overflow-tooltip='true'
            >
              <template slot-scope='scope'>
                                <span v-if='scope.row.customerSex == 0'
                                >男</span
                                >
                <span v-if='scope.row.customerSex == 1'
                >女</span
                >
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" prop="teamName" label="所属团队" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="detailAddress" label="居住地址" :show-overflow-tooltip="true"></el-table-column> -->
          </el-table>
          <div class='pagination_container'>
            <el-pagination
              @size-change='handleSizeChange1'
              @current-change='handleCurrentChange1'
              :current-page='currentPage1'
              :page-sizes='[10, 20, 50, 100]'
              :page-size='10'
              layout='total, sizes, prev, pager, next, jumper'
              :total='total3'
            ></el-pagination>
          </div>
        </div>
        <span slot='footer' class='dialog-footer'>
                    <!-- <el-button type="primary" @click="saveVolunteer" >确 定</el-button>
        <el-button @click="enteringDialog = false">取 消</el-button> -->
                    <el-button type='primary' @click='saveRY'>确 定</el-button>
                    <el-button @click='enteringLYDialog = false'
                    >取 消</el-button
                    >
                </span>
      </el-dialog>

      <!-- 查看详情弹框 -->
      <el-dialog
        :title='enteringDialogTitle'
        :visible.sync='enteringDialog'
        width='60%'
        class='dialog_container'
        @close='enteringDialogClose'
      >
        <div class='dialog_content'>
          <el-table
            :data='xiangqingTableData'
            tooltip-effect='dark'
            style='width: 100%'
            :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
            border
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column
              type='index'
              width='70'
              label='序号'
              align='center'
            ></el-table-column>
            <!-- <el-table-column align="center" prop="volunteerArchiveCode" label="序号" :show-overflow-tooltip="true"></el-table-column> -->
            <el-table-column
              align='center'
              prop='menuDate'
              label='时间'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='meal'
              label='订餐类型'
              :show-overflow-tooltip='true'
            >
              <template slot-scope='scope'>
                <span v-if='scope.row.meal == 1'>早餐</span>
                <span v-if='scope.row.meal == 2'>中餐</span>
                <span v-if='scope.row.meal == 3'>晚餐</span>
              </template>
            </el-table-column>
            <el-table-column
              align='center'
              prop='foodPrice'
              label='订餐金额'
              :show-overflow-tooltip='true'
            ></el-table-column>
            <el-table-column
              align='center'
              prop='allfoodPrice'
              label='总金额'
              :show-overflow-tooltip='true'
            ></el-table-column>
          </el-table>
          <div class='pagination_container'>
            <!-- :page-sizes="[10, 20, 50, 100]"
                            :page-size="10" -->
            <el-pagination
              :page-size='10'
              :current-page='pageNo2'
              :page-sizes='[10, 20, 50, 100]'
              layout='total, sizes, prev, pager, next, jumper'
              :total='total2'
              @size-change='handletableDataSize2'
              @current-change='handleTableDataChange2'
            ></el-pagination>
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveVolunteer" >确 定</el-button>
        <el-button @click="enteringDialog = false">取 消</el-button>
      </span> -->
      </el-dialog>
    </div>

    <!-- 订餐记录 -->
    <el-dialog title='订餐记录' :visible.sync='visVisible1' width='990px'>
      <!-- :data="tableDate10" -->
      <el-table
        ref='print'
        :data='tableDate1'
        tooltip-effect='dark'
        highlight-current-row
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column
          type='index'
          width='70'
          prop='order'
          label='序号'
          align='center'
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop='orderTimeStr'
          label='时间'
          align='center'
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop='orderWay'
          label='订餐方式'
          align='center'
          show-overflow-tooltip
        >
          <template slot-scope='scope'>
            <span v-if="scope.row.orderWay == '0'">按月</span>
            <span v-if="scope.row.orderWay == '1'">按次</span>
          </template>
        </el-table-column>
        <el-table-column
          prop='takeWay'
          label='取餐方式'
          align='center'
          show-overflow-tooltip
        >
          <template slot-scope='scope'>
            <span v-if='scope.row.takeWay == 0'>送餐</span>
            <span v-if='scope.row.takeWay == 1'>堂食</span>
            <span v-if='scope.row.takeWay == 2'>自取</span>
          </template>
        </el-table-column>
        <el-table-column
          prop='orderMoney'
          label='金额'
          align='center'
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop='orderType'
          label='定餐情况'
          align='center'
          show-overflow-tooltip
        >
          <template slot-scope='scope'>
            <span v-if='scope.row.orderType == 1'>早餐</span>
            <span v-if='scope.row.orderType == 2'>午餐</span>
            <span v-if='scope.row.orderType == 3'>晚餐</span>
          </template>
        </el-table-column>
        <el-table-column
          prop='istake'
          label='是否就餐'
          align='center'
          show-overflow-tooltip
        >
          <template slot-scope='scope'>
            <span v-if='scope.row.istake == 0'>未完成</span>
            <span v-if='scope.row.istake == 1'>用餐完成</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change='handleSizeChange4'
        @current-change='handleCurrentChange4'
        :current-page='currentPage'
        :page-sizes='[10, 20, 50, 100]'
        :page-size='10'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total4'
      ></el-pagination>
      <div slot='footer'>
        <el-button type='primary' @click='stamp'>打印</el-button>
        <el-button @click='visVisible1 = false'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getQuestionList} from "../api/index"
import common from '@/utils/common.js'
import request from '@/utils/request.js'
import visitMain from "./visitMain"
import baseURL from '@/api/baseURL'
import '@/utils/addToolbar'
export default {
  name:"orderingInfo",
  components:{ visitMain },
  data() {
    return {
       nextText: "下一步",
       hfData: { id: "" },
       openData: {},
        pList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      endTime: 0,
      orgList: [],
      arrOrgList: [],
      // tableDate10:[],
      pageNo2: 1,
      pageSize2: 10,
      RYXQ: [],
      RYXQ1: [],
      customerName: '',
      phoneNumber: '',

      form1: [],

      total2: 0,
      total3: 0,
      total4: 0,
      enteringLYDialog: false,
      enteringLRTitle: '人员信息',
      RYTableData: [],
      enteringDialogTitle: '查看详情',
      enteringDialog: false,
      //查看详情
      xiangqingTableData: [
        {
          // time:'',
          // dclx:'',
          // dcje:'',
          // dczje:'',
          // volunteerArchiveCode: '',//志愿者编号
          // userName: '',//用户姓名
          // gender: '',//性别
          // mobile: '',//手机号
          // teamName: '',//所属团队
          // detailAddress: '',//居住地址
          // age: '',//年龄
        }
      ],
      // 图片地址
      actionUrl:
        baseURL + '/sqyl/controller/uploadController/info/uploadPhoto',
      // 图片上传
      dialogImageUrl: '',
      dialogVisible1: false,
      photo: [],
      // 表单验证
      rules: {
        orderType: [
          {
            required: true,
            message: '请选择订餐类型',
            trigger: 'change'
          }
        ],
        orderWay: [
          {
            required: true,
            message: '请选择订餐方式',
            trigger: 'change'
          }
        ],
        takeWay: [
          {
            required: true,
            message: '请选择取餐方式',
            trigger: 'change'
          }
        ]
      },
      addFormRules1: {
        customerName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        orgName: [
          {
            required: true,
            message: '请选择组织机构',
            trigger: 'change'
          }
        ],
        customerIdcard: [
          {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '证件号码格式有误！',
            trigger: 'blur'
          }
        ]
      },
      // 订餐记录
      visVisible1: false,
      tableDate1: [],
      // 图片上传
      imgdialog: false,
      // 地图显示
      mapshow: false,
      showtext: true,
      // 新增功能模态框初始状态
      // --------------------------------------------
      // 筛选数据功能按钮初始值
      checkList: [
        '序号',
        '姓名',
        '餐补类型',
        '订餐方式',
        '取餐方式',
        '余额',
        '剩余就餐次数',
        '操作'
      ],
      // --------------------------------------------
      // 新增模态框导航
      dialogTabs: ['基本信息', '订餐信息','回访信息'],
      borderBotKey: 0,
      dialogBox: 0,
      dialogTitle: '',
      // 新增模态框性别
      sexOptions: [
        {
          value: '0',
          label: '男'
        },
        {
          value: '1',
          label: '女'
        }
      ],
      cityList: [], //市级地名列表
      countyList: [], //县区级地名列表
      monthly: false,
      // 订餐地址显示
      showad: false,
      // 新增模态框部门
      subsidyLevelOptions: [],
      // 餐补类型
      foodLevelOptions: [],
      // 送餐员
      personIdOptions: [],
      // --------------------------------------------
      // 新增模态框居住情况
      live: '',
      // --------------------------------------------
      // from表单
      tableDate: [],
      // --------------------------------------------
      // 新增模态框
      addForm: {
        faceIdcode: '',
        orderWay: '',
        orderTimeOnec: [],
        customerPolitical: '',
        photo: '',
        customerName: '',
        customerIdcard: '',
        customerBirthday: '',
        customerAge: '',
        customerSex: '',
        customerPhone: '',
        customerAddress: '',
        provinceId: '', //省
        cityid: '', //市
        zoneid: '', //区
        streetid: '', //街道
        shequid: '', //社区
        longitude: '', //经度
        latitude: '', //纬度
        address: '', //详细地址
        customerJzqk: '',
        economySource: [],
        serviceStation: '',
        orderStartTime: '',
        orderEndTime: '',
        orderType: [],
        orderMoney: '',
        orderBalance: '',
        takeWay: '',
        isAddress: '',
        subsidyBalance: '',
        totalMoney: '',
        customerPhoto: ''
      },
      orderType: [],
      // 民族
      nation: [
        '汉族',
        '蒙古族',
        '回族',
        '藏族',
        '维吾尔族',
        '苗族',
        '彝族',
        '壮族',
        '布依族',
        '朝鲜族',
        '满族',
        '侗族',
        '瑶族',
        '白族',
        '土家族',
        '哈尼族',
        '哈萨克族',
        '傣族',
        '黎族',
        '傈僳族',
        '佤族',
        '畲族',
        '高山族',
        '拉祜族',
        '水族',
        '东乡族',
        '纳西族',
        '景颇族',
        '柯尔克孜族',
        '土族',
        '达斡尔族',
        '仫佬族',
        '羌族',
        '布朗族',
        '撒拉族',
        '毛南族',
        '仡佬族',
        '锡伯族',
        '阿昌族',
        '普米族',
        '塔吉克族',
        '怒族',
        '乌孜别克族',
        '俄罗斯族',
        '鄂温克族',
        '德昂族',
        '保安族',
        '裕固族',
        '京族',
        '塔塔尔族',
        '独龙族',
        '鄂伦春族',
        '赫哲族',
        '门巴族',
        '珞巴族',
        '基诺族'
      ],
      // 图片地址
      imageUrl: '',
      // --------------------------------------------
      // 筛选按钮功能控制表头是否显示初始状态
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      no8: true,
      // --------------------------------------------
      // 批量删除
      selectedData: [],
      // 功能按钮显示初始状态
      quanbu: true,
      currentPage: 1, //默认展示第一页
      currentPage1: 1, //默认展示第一页
      total: 0, //总数据
      timer: '', //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
      currentTime1: new Date(), // 获取当前时间
      searchValue: true,
      showSlide: true,
      editableTabsValue: '1',
      tabIndex: 1,
      input: '',
      value: '',
      valueSq: '',
      myData: [],
      multipleSelection: [],
      currentPage4: 4,
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      form: {
        customerName: '',
        serviceStation: '',
        pageNo: 1,
        pageSize: 10
      },
      visVisible: false,
      userform: {},
      formSwitch: 2,
      familyform: {},
      arorreset: 'add',
      dialogVisible: false,
      // 所有图片名集合
      imgTitleList: ['photo'],
      provinceList: [], //省列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      marker: null, //地图标记点
      polygons: [],
      isMap: true,
      normalInfo: {}
    }
  },
  inject: ['reload'], //注入
  computed: {
    pickerOptions: function() {
      const _this = this
      return {
        disabledDate(time) {
          const licenseStart = _this.endTime
          const month = 1 * 24 * 60 * 60 * 1000
          // licenseStart.setDate(licenseStart.getDate() + 1)
          return time.getTime() <= new Date() - month || time.getTime() > licenseStart
          // return time.getTime() < licenseStart + new Date().getTime()
        }
      }
    }
  },
  methods: {
     setQuestionId(v) {
      let index = this.pList.findIndex((item) => item.id == v)
      this.hfData.id = v
      this.$set(this.hfData, "questionList", this.pList[index].problemList)
    },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    handleEditNodeClick(data, node) {
      const clickNode = this.$refs.tree.getNode(node)
      const arr = []
      this.loopNode(clickNode, arr)
      this.arrOrgList = arr
      let obj = common.organization(
        this.arrOrgList,
        this.normalInfo.orgLevel
      )
      this.$set(this.addForm, 'orgId', data.orgId)
      this.$set(this.addForm, 'parentId', data.parentId)
      this.$set(this.addForm, 'orgType', data.orgType)
      this.$set(this.addForm, 'orgName', data.label)

      this.$set(this.addForm, 'qujiId', obj.qujiId)
      this.$set(this.addForm, 'shengjiId', obj.shengjiId)
      this.$set(this.addForm, 'shijiId', obj.shijiId)
      this.$set(this.addForm, 'stationId', obj.stationId)
      this.$set(this.addForm, 'shequjiId', obj.shequjiId)
      this.$refs['selectBoxRef'].handleClose()
    },
    getOrg() {
      this.$http
        .request({
          url: '/rbac/admin/org/info/findOrgById',
          method: 'POST',
          data: { id: this.$store.state.info.orgId }
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.addForm.shequid,
        citylimit: true,
        input: input
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, 'select', (e) => {
        self.addForm.customerAddress = e.poi.name
        self.addForm.addressLng = e.poi.location.lng
        self.addForm.addressLat = e.poi.location.lat
        console.log(e.poi.location, '地址')
        self.potintMap()
      })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        '机构信息 normalInfo.orgLevel',
        this.provinceList
      )
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ''
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(
          this.normalInfo.provinceId
        )
        this.cityList = cityList.districtList
        console.log('城市', this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ''
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getDistricts(this.normalInfo.areaId)
        this.streetList = streetList.districtList
      } else {
        this.normalInfo.areaId = ''
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(
          this.normalInfo.streetId
        )
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ''
      }
      if (
        this.normalInfo.orgLevel == 1 ||
        this.normalInfo.orgLevel == 0
      ) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      }
      this.potintMap()

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = String(
          this.normalInfo.communityId
        )
      } else {
        this.normalInfo.communityId = ''
      }

      this.addForm.provinceId = this.normalInfo.provinceId
      this.addForm.cityid = this.normalInfo.cityId
      this.addForm.zoneid = this.normalInfo.areaId
      this.addForm.streetid = this.normalInfo.streetId
      this.addForm.shequid = this.normalInfo.communityId
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 点击时间
    linkage(e) {
      let date1 = new Date().setTime(new Date(e).getTime()) + 3600 * 1000 * 24 * 30
      let date2 = new Date(date1)
      let y = date2.getFullYear()// 年
      let MM = date2.getMonth() + 1// 月
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date2.getDate()// 日
      d = d < 10 ? ('0' + d) : d
      var timer = y + '-' + MM + '-' + d
      console.log(timer)
      this.addForm.orderEndTime = timer
    },
    groupCheck(val) {
      this.$http
        .request({
          url: '/sqyl/admin/order/getOrderMoney',
          method: 'POST',
          data: {
            // economySource: this.addForm.orderTimeOnec.toString(),
            orderTimeOnec: this.addForm.orderTimeOnec.toString(),
            orderType: this.addForm.orderType.toString()
          }
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.content) {
              console.log(res.content)
              this.addForm.orderMoney = res.content
            }
          }
        })

      console.log(val)
    },
    // 点击按月
    exchange(e) {
      console.log(e)
      if (e == 0) {
        this.addForm.orderType = ['1', '2', '3']
        this.monthly = true
      } else {
        this.addForm.orderType = []
        this.monthly = false
      }
    },
    // 获取时间
    showList1() {
      this.$http.request({
        url: '/sqyl/admin/weeklyMenu/selectAll ',
        method: 'POST',
        data: {
          pageNo: 1,
          pageSize: 10
        }
      })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              // this.tableDatas = []
              // this.total1 = 0
              this.endTime = Date.now()
              return
            }
            this.endTime = (new Date(res.content.list[0].endTime)).getTime()
          }
        })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url:
              '/ypt/admin/standardAddress/info/StandardAddressTree',
            method: 'POST',
            data: {
              jiedaoId: val
            }
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 打点
    potintMap() {
      var map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 8,
        // zooms: [3, 20],
        expandZoomRange: true,
        center: [
          Number(this.addForm.addressLng),
          Number(this.addForm.addressLat)
        ]
      })
      var marker = new AMap.Marker({
        position: [
          Number(this.addForm.addressLng),
          Number(this.addForm.addressLat)
        ],
        map: map
      })
      map.setFitView(marker)
    },
    //街道地址发生变化
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = '中国', params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: 'all',
          showbiz: false //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: '', //城市设为北京，默认：“全国”
          radius: 1000 //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == 'complete') {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    async handleCurrentChange4(val) {
      // console.log(val,1)
      // console.log(this.tableDate1)
      // // await this.look1()
      // this.tableDate10 = this.tableDate1.slice((val-1)*10,(10+(val-1)*10))
    },
    handleSizeChange4() {
    },
    handletableDataSize2(val) {
      this.pageSize2 = val
      console.log(val, 1)
      this.showVolunteerList()
    },
    handleTableDataChange2(val) {
      this.pageNo2 = val
      console.log(val, 1)
      this.showVolunteerList()
    },
    async saveRY() {
      // console.log(this.RYXQ1.length)
      console.log(this.RYXQ1)
      console.log(this.RYXQ1[0])
      if (this.RYXQ1) {
        if (this.RYXQ1.length != 1) {
          this.$message({
            message: `请选择一个人员`,
            type: 'error'
          })
        } else {
          let ry = this.RYXQ1[0]
          console.log(ry.economySource, 'ry.economySource')
          this.addForm = {
            ...ry,
            economySource: ry.economySource.split(','),
            orderType: [],
            provinceId: String(ry.provinceId),
            cityid: String(ry.cityid),
            zoneid: String(ry.zoneid),
            streetid: String(ry.streetId),
            shequid: Number(ry.shequid),
            orderBalance: ry.totalMoney
          }

          this.enteringLYDialog = false
          let self = this
          // let jsonTemp = { ...this.addForm };
          // if (!jsonTemp.provinceId) return;
          let city = await self.getDistricts(this.addForm.provinceId)
          self.cityList = city.districtList
          if (!this.addForm.cityid) return
          let area = await self.getDistricts(this.addForm.cityid)
          self.areaList = area.districtList
          if (!this.addForm.zoneid) return
          let street = await self.getDistricts(this.addForm.zoneid)
          self.streetList = street.districtList
          // this.addForm.streetId = String(this.addForm.streetId)
          if (!this.addForm.streetid) return
          let communityList = await self.getCommityList(
            this.addForm.streetid
          )
          console.log(communityList, '社区名称')
          this.communityList = communityList
          this.$forceUpdate()
        }
      }
    },
    handleSelectionChange1(rows) {
      this.RYXQ = rows
      console.log(this.RYXQ)
    },
    handleSelectionChange1(data) {
      this.RYXQ1 = data
      console.log(this.RYXQ1)
    },
    //用户列表
    async showlist1() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/customer/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.RYTableData = res.content.list
          this.total3 = res.content.count
        }
        console.log(this.RYTableData)
      })
    },
    // 查询
    async query1() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form1,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/customer/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        if (res.content != null) {
          this.RYTableData = res.content.list
          this.total = res.content.count
        } else {
          this.RYTableData = []
        }
      })
    },

    // 人员信息
    enteringLRClose() {
    },
    lookRY() {
      this.enteringLYDialog = true
      this.showlist1()
    },
    // showRYList(){
    //   this.showlist1()
    // },
    // 详细信息
    enteringDialogClose() {
      console.log(this.addForm.orderMoney, this.addForm.orderBalance)
      if (this.addForm.orderMoney > this.addForm.orderBalance) {
        console.log(1)
        this.$message({
          message: `余额不足，请充值`,
          type: 'warning'
        })
      }
    },
    addVolunteer() {
      this.enteringDialog = true
      // this.showVolunteerList();
    },
    // 表格内容
    async showVolunteerList() {
      console.log(this.addForm)
      let params = {
        pageNo: this.pageNo2,
        pageSize: this.pageSize2,
        orderStartTime: this.addForm.orderStartTime,
        orderEndTime: this.addForm.orderEndTime,
        meals: this.addForm.orderType
      }
      let params1 = {
        pageNo: this.pageNo2,
        pageSize: this.pageSize2,
        orderTimeOnec: this.addForm.orderTimeOnec,
        meals: this.addForm.orderType
      }
      params = Object.assign({}, params)
      params1 = Object.assign({}, params1)
      // console.log(params)
      // console.log(params1)
      // return
      if (this.addForm.orderWay == 1) {
        await request({
          url: '/sqyl/admin/weeklyMenu/findDateFoodList',
          method: 'POST',
          data: params1
        }).then((res) => {
          console.log(res)
          this.xiangqingTableData = res.content
          this.total2 = res.content.length
          let c = 0
          this.xiangqingTableData.forEach((item, index) => {
            // console.log(item.allfoodPrice)
            // c +=item.allfoodPrice
            c += Number(item.allfoodPrice)
          })
          console.log(c)
          this.addForm.orderMoney = c
        })
      } else {
        await request({
          url: '/sqyl/admin/weeklyMenu/findDateFoodList',
          method: 'POST',
          data: params
        }).then((res) => {
          console.log(res)
          this.xiangqingTableData = res.content
          this.total2 = res.content.length
          let c = 0
          this.xiangqingTableData.forEach((item, index) => {
            // console.log(item.allfoodPrice)
            // c +=item.allfoodPrice
            c += Number(item.allfoodPrice)
          })
          console.log(c)
          this.addForm.orderMoney = c
        })
      }
    },
    // 筛选功能按钮
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == '序号') == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (this.checkList.findIndex((obj) => obj == '姓名') == -1) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '餐补类型') == -1
        ) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '订餐方式') == -1
        ) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '取餐方式') == -1
        ) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == '余额') == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == '操作') == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
        if (
          this.checkList.findIndex((obj) => obj == '剩余就餐次数') ==
          -1
        ) {
          this.no8 = false
        } else {
          this.no8 = true
        }
      }
    },
    // 搜索用户信息
    searchPerson(val) {
      let id = val
      if (val) {
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          customerIdcard: id,
          qujiId: JSON.parse(localStorage.getItem('czUserInfo'))
            .qujiId,
          shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
            .shengjiId,
          shijiId: JSON.parse(localStorage.getItem('czUserInfo'))
            .shijiId,
          stationId: JSON.parse(localStorage.getItem('czUserInfo'))
            .stationId,
          shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
            .shequjiId
        }
        params = Object.assign({}, params)
        request({
          url: '/sqyl/admin/customer/info/findList',
          method: 'POST',
          data: params
        }).then((res) => {
          this.addForm = res.content.list[0]
          this.addForm.economySource = res.content.list[0].economySource.split(
            ','
          )
          this.addForm.orderType = res.content.list[0].orderType.split(
            ','
          )
          console.log(this.addForm)
        })
      }
      //出身年月
      var birthday = ''
      if (val != null && val != '') {
        if (val.length == 15) {
          birthday = '19' + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
      }
      this.addForm.customerBirthday = birthday
      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.addForm.customerSex = '1'
        } else {
          this.addForm.customerSex = '0'
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.addForm.customerSex = '1'
        } else {
          this.addForm.customerSex = '0'
        }
      } else {
        return ''
      }
    },
    // 查询
    async query() {
      let params = {
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,

        ...this.form
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/order/selectByCondition',
        method: 'POST',
        data: params
      }).then((res) => {
        if (res.content != null) {
          this.tableDate = res.content.list
          this.total = res.content.count
        } else {
          this.tableDate = []
        }
      })
    },

    // 点击编辑
    handleClick(type, date) {
      console.log(type, date)
      let self = this
      this.dialogBox = 0
      this.mapshow = false
      this.borderBotKey = 0
      this.dialogVisible = true
      this.dialogTitle = type
      this.showad = false
      this.showList1()
      this.resetForm('addForm1')
      this.resetForm('addForm2')
      // this.mapInit("container");
      this.showlist()
      setTimeout(async () => {
        await this.$nextTick(() => self.loadmap('container'))
      }, 30)
      switch (type) {
        case '新增':
          this.addForm.orderEndTime = ''
          break
        case '查看':
          this.look(date)
          break
        case '编辑':
          this.look(date)
          break
      }
    },
    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },

    // 删除
    deleteItem(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
        orderId: date.id
      }
      params = Object.assign({}, params)
      this.$confirm('确认删除订单信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/sqyl/admin/order/deleteById',
          method: 'POST',
          data: params
        }).then((res) => {
          if ((res.code = 200)) {
            this.showList()
          }
        })
      })
    },
    // end

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.showtext = !this.showtext
      this.row = row
      this.column = column
    },
    handleSelectionChange(data) {
      this.selectedData = data
    },
    batchDelete() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.$confirm('确认删除选中订餐信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            val.forEach(function(item, index) {
              request({
                url: '/sqyl/admin/order/deleteById',
                method: 'POST',
                data: { id: item.id, orderId: item.id }
              })
            })
          })
          .then(() => {
            this.showList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
      } else {
        this.$confirm('请选择要删除的项。', '提示')
      }
      this.$refs.multipleTable.clearSelection()
    },

    // 新增功能模态框打开事件
    opendialogVisible() {
      this.dialogVisible = true
    },
    //新增模态框导航样式选择事件
    selectDialogTabs(index) {
      this.borderBotKey = index
      this.dialogBox = index;
      if(index == 2){ //信息回访
          this.openData = {
                id: 1151,
                commId: 1,
                data:{
                  address: "地铁1号线",
                  addressLat: 33.8397,
                  addressLng: 111.554,
                  age: 99
                },
                nums: 0,
                state: true,
                title: "查看"
            }
      } 
    },
    showSearch() {
      this.searchValue = !this.searchValue
    },
    // 重置
    resert() {
      this.form = {}
      this.dialogBox = 1
      this.showList()
    },
    //拿到列表数据
    async showList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/order/selectByCondition',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.tableDate = res.content.list
          this.total = res.content.count
        } else {
          this.tableDate = []
        }
      })
    },

    // 表单刷新
    resertTable() {
      this.showList()
      this.checkList = [
        '序号',
        '姓名',
        '餐补类型',
        '订餐方式',
        '取餐方式',
        '余额',
        '操作'
      ]
      this.tableShow()
    },
    // 查看
    async look(date) {
      let params = {
        // pageNo: this.pageNo,
        // pageSize: this.pageSize,
        id: date.id
      }
      //   params = Object.assign({}, params)
      request({
        url: '/sqyl/admin/order/findById',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        let cd = res.content
        console.log(cd.orderTimeOnec, 'string11')
        // 送餐时间转换
        if (typeof cd.orderTimeOnec === 'string') {
          cd.orderTimeOnec = cd.orderTimeOnec.split(',')
          //   cd.orderTimeOnec = JSON.parse(cd.orderTimeOnec)
        } else {
          cd.orderTimeOnec = []
        }
        console.log(cd.orderTimeOnec, 'string18881')
        // this.addForm = res.content;

        // console.log(cd.customerId)
        let params1 = {
          id: cd.customerId
        }
        // console.log(params1)
        params1 = Object.assign({}, params1)
        request({
          url: '/sqyl/admin/customer/info/findById',
          method: 'POST',
          data: params1
        }).then(async (res) => {
          console.log(res)
          // console.log(cd);
          this.addForm = {
            ...res.content,
            ...cd,
            customerIdcard: res.content.customerIdcard,
            provinceId: String(res.content.provinceId),
            cityid: String(res.content.cityid),
            zoneid: String(res.content.zoneid),
            streetid: String(res.content.streetId),
            shequid: Number(res.content.shequid)
          }
          console.log(this.addForm)
          // this.formData.serviceType=res.content.serviceType.split(',');
          this.addForm.economySource = res.content.economySource.split(
            ','
          )
          if (cd.orderType.length > 0) {
            this.addForm.orderType = cd.orderType.split(',')
          } else {
            this.addForm.orderType = []
          }
          let self = this
          let jsonTemp = { ...this.addForm }
          console.log(jsonTemp, 'jsonTemp')
          if (!jsonTemp.provinceId) return
          let city = await self.getDistrict(jsonTemp.provinceId)
          self.cityList = city.districtList
          if (!jsonTemp.cityid) return
          let area = await self.getDistrict(jsonTemp.cityid)
          self.areaList = area.districtList
          if (!jsonTemp.zoneid) return
          let street = await self.getDistrict(jsonTemp.zoneid)
          self.streetList = street.districtList
          if (!jsonTemp.streetid) return
          let communityList = await self.getCommityList(
            this.addForm.streetid
          )
          this.communityList = communityList

          this.selectDepart(this.addForm.departmentId)
          if (this.addForm.takeWay == '0') {
            this.showad = true
          }
          // this.mapshow=true
        })

        //  if (res.content.orderType.lenght > 0) {
        //     this.addForm.orderType = res.content.orderType.split(
        //         ","
        //     );
        // } else {
        //     this.addForm.orderType = [];
        // }
        // if (res.content.economySource.lenght > 0) {
        //     this.addForm.economySource = res.content.economySource.split(
        //         ","
        //     );
        // } else {
        //     this.addForm.economySource = [];
        // }
      })
    },

    // 订餐记录
    showDialog(date) {
      // console.log(date);
      this.look1(date)
      this.visVisible1 = true
    },
    // 查看人员订餐
    look1(date) {
      console.log(date)
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        customerId: date.customerId,
        orderId: date.id
      }
      request({
        url: '/sqyl/admin/order/findOrderByPerson',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        this.tableDate1 = res.content
        this.total4 = res.content.length
        // this.tableDate10 = this.tableDate1.slice(0,10)
        // this.addForm.economySource = this.addForm.economySource.split(",");
      })
    },

    //每页请求数据
    handleSizeChange(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageSize = val
      // this.showList();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: 'success'
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageNo = val
      this.showList()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: 'success'
      })
    },

    handleSizeChange1(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageSize = val
      // this.showList();
      this.showlist1()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: 'success'
      })
    },
    //请求第几数据
    handleCurrentChange1(val) {
      console.log('editableTabs=>', this.editableTabs)
      this.pageNo = val
      this.showlist1()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: 'success'
      })
    },
    // 刷新页面
    Resert() {
      this.reload()
    },
    // 上传图片
    changeupload() {
      this.imgdialog = true
    },
    submitUpload() {
      this.$refs.upload.submit()
    },

    helpListOut(params) {
      return request2({
        url: '/sqyl/admin/person/info/downloadPerson',
        method: 'POST',
        data: params,
        responseType: 'blob'
      })
    },
    // 地图显示
    location() {
      this.mapshow = !this.mapshow
      setTimeout(async () => {
        await this.$nextTick(() => this.loadmap('container'))
      }, 30)
    },
    getTime(time) {
      let now = new Date(time)
      return now.getTime()
    },
    // 保存
    submitForm() {
      if (!this.addForm.orderType) {
        this.$message.error('订餐类型为必填项，请选择')
        return
      }
      this.$refs.addForm1.validate((valid1) => {
        if (valid1) {
          this.$refs.addForm2.validate((valid2) => {
            if (valid2) {
              if (!this.addForm.provinceId) {
                this.$message.error('省级地址为必填项，请选择')
                return
              }
              if (!this.addForm.cityid) {
                this.$message.error('市级地址为必填项，请选择')
                return
              }
              if (!this.addForm.zoneid) {
                this.$message.error(
                  '区县级地址为必填项，请选择'
                )
                return
              }
              if (!this.addForm.streetid) {
                this.$message.error('街道地址为必填项，请选择')
                return
              }
              // if (
              //     this.formData.shequid === "" ||
              //     this.formData.shequid === null ||
              //     this.formData.shequid === undefined
              // ) {
              //     this.$message.error(
              //         "社区为必填项，请选择,如无对应社区，请地址管理配置"
              //     )
              //     return
              // }
              if (!this.addForm.customerAddress) {
                this.$message.error(
                  '详细信息为必填项，请在地图的边界内点击选择或手动输入'
                )
                return
              }
              let obj = common.organization(
                this.arrOrgList,
                this.normalInfo.orgLevel
              )
              let params
              console.log(this.dialogTitle)
              // 送餐时间转换
              // this.addForm.orderTimeOnec = this.addForm.orderTimeOnec.join(',')
              this.addForm.orderTimeOnec = this.addForm.orderTimeOnec.toString()
              if (this.addForm.orderWay == 1) {
                this.addForm.orderStartTime = ''
                this.addForm.orderEndTime = ''
              }
              let orderStartTime = this.getTime(
                this.addForm.orderStartTime
              )
              let orderEndTime = this.getTime(
                this.addForm.orderEndTime
              )
              if (orderStartTime > orderEndTime) {
                this.$message.error(
                  '订餐结束时间不能小于订餐开始时间'
                )
                return
              }
              if (this.addForm.orderWay == 0) {
                this.addForm.orderTimeOnec = ''
              }
              if (this.dialogTitle == '新增') {
                params = {
                  pageNo: this.pageNo,
                  pageSize: this.pageSize,
                  ...this.addForm,
                  customerId: this.addForm.id,
                  oldmanType: this.addForm.subsidyLevel,
                  economySource: this.addForm.economySource.toString(),
                  orderType: this.addForm.orderType.toString(),
                  qujiId: obj.qujiId,
                  shengjiId: obj.shengjiId,
                  shijiId: obj.shijiId,
                  stationId: obj.stationId,
                  shequjiId: obj.shequjiId,
                  orgName: obj.orgName,
                  orgId: obj.orgId
                }
                delete params.id
              } else {
                params = {
                  pageNo: this.pageNo,
                  pageSize: this.pageSize,
                  ...this.addForm,
                  economySource: this.addForm.economySource.toString(),
                  orderType: this.addForm.orderType.toString()
                }
              }
              // delete params.id,
              params = Object.assign({}, params)

              if (
                parseInt(this.addForm.orderMoney) >
                parseInt(this.addForm.orderBalance)
              ) {
                console.log(
                  this.addForm.orderMoney >
                  this.addForm.orderBalance
                )
                console.log(this.addForm.orderMoney)
                console.log(this.addForm.orderBalance)
                this.$message({
                  message: `余额不足，请充值`,
                  type: 'warning'
                })
              } else {
                request({
                  url: '/sqyl/admin/order/insert',
                  method: 'POST',
                  data: params
                }).then((res) => {
                  delete params.id
                  // console.log(res);
                  if (res.code == 200) {
                    this.$message({
                      message: `新增订单成功`,
                      type: 'success'
                    })
                    this.dialogVisible = false
                    this.showList()
                  } else {
                    this.$message({
                      message: `新增订单失败`,
                      type: 'warning'
                    })
                  }
                })
              }
            } else {
              this.dialogBox = 1
            }
          })
        }
      })
    },
    // 取消
    cancel(formName) {
      this.dialogBox = 1
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.mapshow = false
    },
    // 关闭
    handleClose() {
      this.dialogBox = 1
      this.dialogVisible = false
      this.mapshow = false
    },
    // 打印
    stamp() {
      this.$print(this.$refs.print)
    },

    // 表单重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },

    // 订餐地址显示
    showAddress() {
      if (this.addForm.takeWay == '0') {
        this.showad = true
      } else {
        this.showad = false
      }
    },

    chickpage(e) {
      this.formSwitch = e
    },

    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个图片，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.customerPhoto = res.content
    },
    // 地图
    getMap(input) {
      const autoOptions = {
        city: this.addForm.zoneid,
        citylimit: true,
        input: input
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, 'select', (e) => {
        console.log('e', e)
        const marker = new AMap.Marker({
          icon:
            'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          position: e.poi.location
        })
        // 删除之前的定位点
        // const MarkerList = this.myMap.getAllOverlays().filter(item => item.CLASS_NAME === 'AMap.Marker')
        const MarkerList = this.myMap.getAllOverlays()
        this.myMap.remove(MarkerList)
        // 设置选择的坐标点
        this.myMap.add(marker)
        this.myMap.setFitView()
        this.addForm.customerAddress = e.poi.name
        this.addForm.longitude = e.poi.location.lng
        this.addForm.latitude = e.poi.location.lat
      })
    },
    //获取地址
    getDistrict(name = '中国', params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: 'all',
          showbiz: false //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: '', //城市设为北京，默认：“全国”
          radius: 1000 //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == 'complete') {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log('移除地图编辑出错了')
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: '#0091ea',
                  fillColor: '#80d8ff',
                  fillOpacity: 0.4,
                  path: bounds[i]
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on('click', function(e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(
                      lnglat,
                      function(status, result) {
                        if (
                          status === 'complete' &&
                          result.regeocode
                        ) {
                          var address =
                            result.regeocode
                              .formattedAddress
                          self.addForm.customerAddress = address
                          self.addForm.longitude =
                            lnglat.lng
                          self.addForm.latitude =
                            lnglat.lat
                        } else {
                          console.error(
                            '根据经纬度查询地址失败'
                          )
                        }
                      }
                    )
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([
                      params.longitude,
                      params.latitude
                    ])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.cityid = ''
      this.addForm.zoneid = ''
      this.addForm.streetid = ''
      this.addForm.shequid = ''
      this.addForm.customerAddress = ''
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.zoneid = ''
      this.addForm.streetid = ''
      this.addForm.shequid = ''
      this.addForm.customerAddress = ''
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.addForm.streetid = ''
      this.addForm.shequid = ''
      this.addForm.customerAddress = ''
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },

    // 餐补类型

    async showlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/subsidyLevel/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        this.foodLevelOptions = res.content.list
      })
    },

    //加载地图
    loadmap(index) {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map(index, {
          resizeEnable: true,
          zoom: 18
        })
        resolve()
      })
    },

    // 部门列表
    async departmentlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        webfrom: '1',
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      await request({
        url: '/sqyl/admin/department/info/findList',
        method: 'POST',
        data: params
      }).then((res) => {
        // console.log(res);
        this.subsidyLevelOptions = res.content.list
      })
    },
    // 选择人员
    selectDepart(val) {
      let params = {
        departmentId: val,
        webfrom: '1',
        qujiId: JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
        shengjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shengjiId,
        shijiId: JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
        stationId: JSON.parse(localStorage.getItem('czUserInfo'))
          .stationId,
        shequjiId: JSON.parse(localStorage.getItem('czUserInfo'))
          .shequjiId
      }
      params = Object.assign({}, params)
      request({
        url: '/sqyl/admin/person/info/findPersonByDept',
        method: 'POST',
        data: params
      }).then((res) => {
        console.log(res)
        this.personIdOptions = res.content
      })
    }
  },
  created() {
    this.getOrg()
    this.getProvince()
    this.showList()
    this.departmentlist()
    // this.mapInit("container");
     this.nums = this.openData.nums
    let communityId = this.openData.commId
     getQuestionList({ communityId, pageSize: 10, pageNo: 1 }).then((res) => {
      let { content } = res
      if (content) {
        let { list } = content
        this.pList = list
      }
    })
    let { evaluationContentId, evaluationContentQuestions } = this.openData.data

    if (
      evaluationContentId &&
      evaluationContentQuestions &&
      evaluationContentQuestions.length
    ) {
      this.hfData.id = evaluationContentId
      this.hfData.questionList = evaluationContentQuestions
    }

   
  },
   watch: {
    nums(n, o) {
      switch (n) {
        case 1:
          this.nextText = "下一步"
          break
        case 2:
          this.nextText = "提交"
          break
      }
    },
    // gdData(n, o) {
    //   //
    // },
  }
}
</script>
<style lang='less' scoped>
//  /deep/ .dialog_container {
//     .el-dialog__header {
//       border-bottom: 1px solid #e5e5e5;
//     }
//     .el-dialog__body {
//       padding-left: 60px;
//       padding-right: 60px;
//     }
//     .dialog_content {
//       .el-col {
//         text-align: center;
//       }
//       .el-select {
//         .el-input__inner {
//           width: 100%;
//         }
//       }
//       .table_add_wraoper {
//         .add_table {
//           margin-top: 24px;
//         }
//       }
//     }
//     .el-dialog__footer {
//       background: #f5f5f5;
//       padding: 8px 15px;
//       border-top: 1px solid #e5e5e5;
//       border-bottom-left-radius: 5px;
//       border-bottom-right-radius: 5px;
//     }
//   }
// 新增功能模态框导航样式
.addFrom {
  .el-dialog__header {
    text-align: center;
  }

  .el-form-item__label {
    border: 1px solid #000;
  }

  .el-form-item {
    // dialog输入框居右对齐
    margin: 0;
    // 输入框
    input {
      height: 30px;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }

  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
  }

  // 新增功能模态框tabs
  .addDialogTabs {
    width: 100%;
    display: flex;
    font-size: 14px;
    justify-content: space-between;

    .borderBot {
      border-bottom: 2px solid #169bd5;
    }

    /deep/ .el-dialog__body {
      padding-top: 0px !important;
    }

    /deep/ .el-dialog__footer {
      text-align: center;
    }
  }

  .addDialogTabs > div {
    cursor: pointer;
    font-size: 14px;
    width: 50%;
    height: 50px;
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #e4e4e4;
  }

  .dialogBody {
    display: flex;
    // width: 100%;
    .dialogBodyright {
      width: 100%;
    }
  }

  /deep/ .el-dialog {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #e6e6e6;
    }

    /deep/ .el-dialog__body {
      padding-top: 0px !important;
    }
  }

  /deep/ .imgdialog {
    /deep/ .el-dialog__body {
      padding-top: 10px !important;
    }
  }

  // 模态框居住情况
  .dialogLiveRadio {
    display: flex;
    align-items: center;
  }
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
  background-color: #f5f5f5;
}

// --------------------------------------------
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldLeftContent {
  height: calc(100% - 68px);
  overflow-y: auto;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 254px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
}

.searchTjHead {
  background: #e6e6e6;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: rgb(0, 0, 0);
  border-color: rgb(217, 217, 217);
  padding: 6px 15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.searchTjContent {
  padding: 15px;
  border: 1px solid rgb(217, 217, 217);

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px) 2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}

/deep/ .el-button {
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

.el-submenu /deep/ .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
.el-tabs--card
> .el-tabs__header
/deep/
.el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-menu .is-active {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .el-menu-item:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
  background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}

/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 400px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

// 上传图片
/deep/ .avatar-uploader {
  border-radius: 5px;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.visitMain {
  padding: 0 40px;
  .visitTitle {
    display: flex;
    .name {
      flex: 1;
    }
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
</style>